import { AnyAction, createAction, Reducer } from '@reduxjs/toolkit'
import type { RemoteSlices } from './protocol'
import { applyFromHost, SyncPolicy } from './sync-policy'

/** Slices from the host, applied by `withRemoteState`. */
export const remoteStateReceived = createAction<{ slices: RemoteSlices }>(
	'replication/remoteStateReceived'
)

/**
 * The root reducer of a replica: the host's slices are applied by the sync
 * policy, every other action goes to the app's reducers as before.
 */
export const withRemoteState =
	<S>(
		reducer: Reducer<S, AnyAction>,
		policy: SyncPolicy<S>
	): Reducer<S, AnyAction> =>
	(state, action) => {
		if (state !== undefined && remoteStateReceived.match(action)) {
			return applyFromHost(state, action.payload.slices, policy)
		}
		return reducer(state, action)
	}
